export const enAgentGuiAddContent = {
  addContentResourcePanel: "Resource panel",
  addContentConnectors: "Connectors",
  addContentConnectorConnected: "Authorized",
  addContentConnectorSelected: "Selected",
  addContentConnectorConnect: "Connect",
  addContentConnectorAuthorize: "Authorize",
  addContentConnectorEmpty: "No connectors available",
  addContentConnectorMore: "View more connectors"
} as const;
